import { RecognitionCoreValueNode } from "types/graphql-schema";

import ComboboxGeneric, {
  ComboboxGenericOption,
} from "@components/combobox/generic-combobox";
import CoreValueIcon from "@components/core-value-icon/core-value-icon";

type InputProps = {
  selectedCoreValueId: number | null;
  coreValues: Pick<
    RecognitionCoreValueNode,
    "emoji" | "image" | "id" | "title"
  >[];
  onChange: (opt: ComboboxGenericOption<number>) => void;
  className?: string;
};

export const CoreValueDropdownInput: React.FC<InputProps> = ({
  selectedCoreValueId,
  coreValues,
  onChange,
}) => {
  if (coreValues.length === 0) {
    return (
      <div className="text-gray-400 text-sm">
        Go to organization settings to configure Core Values
      </div>
    );
  }

  const options = coreValues.map((coreValue) => ({
    value: coreValue.id,
    label: coreValue.title,
    htmlLabel: (
      <span className="flex items-center gap-1.5 max-w-64">
        <CoreValueIcon
          imagePxSize={16}
          image={coreValue.image}
          emoji={coreValue.emoji}
        />
        <span className="flex-1 truncate">{coreValue.title}</span>
      </span>
    ),
  }));

  const selectedCoreValue =
    options.find((coreValue) => coreValue.value === selectedCoreValueId) ||
    null;

  return (
    <ComboboxGeneric<number>
      options={coreValues.map((coreValue) => ({
        value: coreValue.id,
        label: coreValue.title,
        htmlLabel: (
          <span className="flex items-center gap-1.5 max-w-64">
            <CoreValueIcon
              imagePxSize={16}
              image={coreValue.image}
              emoji={coreValue.emoji}
            />
            <span className="flex-1 truncate">{coreValue.title}</span>
          </span>
        ),
      }))}
      value={selectedCoreValue}
      onChangeValue={onChange}
      placeholder="Choose a core value"
    />
  );
};

export default CoreValueDropdownInput;
